import React, { useState } from 'react';
import { patch } from '../core/http';
import { API } from '../core/constants';
import Modal from './ui/Modal';

const EditUnsortedDialog = ({ article, onSaved, onCancel }) => {
  const [title, setTitle] = useState(article.title || '');
  const [summary, setSummary] = useState(article.summary || '');
  const [tags, setTags] = useState(article.tags || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');

    try {
      await patch(`${API}/unsorted/${article.id}`).send({ title, summary, tags });
      onSaved({ ...article, title, summary, tags });
    } catch (err) {
      setError('Could not save changes.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Edit unsorted item" onClose={onCancel}>
      <form onSubmit={handleSave} className="space-y-3">
        <label className="block">
          <span className="label-text text-xs font-semibold">Title</span>
          <input
            className="input input-bordered input-sm w-full mt-1"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </label>

        <label className="block">
          <span className="label-text text-xs font-semibold">Summary</span>
          <textarea
            className="textarea textarea-bordered w-full mt-1"
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            rows={4}
          />
        </label>

        <label className="block">
          <span className="label-text text-xs font-semibold">Tags</span>
          <input
            className="input input-bordered input-sm w-full mt-1"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            placeholder="Comma separated"
          />
        </label>

        {error && <p className="text-error text-xs">{error}</p>}

        <div className="flex gap-2 pt-2">
          <button type="button" className="btn btn-ghost btn-sm flex-1" onClick={onCancel} disabled={saving}>
            Cancel
          </button>
          <button className="btn btn-primary btn-sm flex-1" type="submit" disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EditUnsortedDialog;
